import { createContext, type ReactNode, useContext } from "react";

import { useTechnicalDataScenarios } from "../hooks/useTechnicalDataScenarios";

type TechnicalDataScenarioContextValue = ReturnType<typeof useTechnicalDataScenarios>;

const TechnicalDataScenarioContext = createContext<null | TechnicalDataScenarioContextValue>(null);

type TechnicalDataScenarioProviderProps = {
  children: ReactNode;
  projectId?: string;
};

export const TechnicalDataScenarioProvider = ({ children, projectId }: TechnicalDataScenarioProviderProps) => {
  const value = useTechnicalDataScenarios(projectId);
  return <TechnicalDataScenarioContext.Provider value={value}>{children}</TechnicalDataScenarioContext.Provider>;
};

export const useTechnicalDataScenarioContext = () => {
  const context = useContext(TechnicalDataScenarioContext);
  if (!context) {
    throw new Error("useTechnicalDataScenarioContext must be used within TechnicalDataScenarioProvider");
  }
  return context;
};
